<template >
  <div @click="exportData()">
     <CButton  class="btn btn action-c-btn btn-success m-auto curve-border ">
                <!-- <slot name="jsonExcel"></slot> -->
                    <slot></slot>

              </CButton>
  </div>
</template>

<script>
import {  COMPONENT_NAME } from "./../../util/constants";
import  {
  FILE_NAME,
  LOG_TYPE,
  
} from "./../../config/API_DATA";

import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base.js";
import XLSX from "xlsx";

export default {
  name: COMPONENT_NAME.C_EXPORT_EXCEL,

  props: {
    data: {
      type: Array,
      default: function() {
        return [
        ];
      }
    },
    fields: {
      type: Object,
      default: function() {
        return {
        };
      }
    },
    worksheet: {
      type: String,
      default: null
    },

    title: {
      type: String | Array,
      default: function() {
        return [];
      }
    },
    name: {
      type: String,
      default: null
    },
    isMergeCells: {
      type: Boolean,
      default: false
    }
  },

  data: () => {
    return {};
  },

  mounted() {
    // this.$root.$on("callExport", () => {
    //             this.exportData();
    //         });
    //     this.$root.$on("callExport", isDownload => {
    //   if (isDownload) {
    //      this.exportData();  
    //   } 
    // });
  },

  computed: {
    FIELDS() {
      return this.fields;
    },

    DATA() {
      return this.data;
    }
  },

  methods: {
    getMergeColumns(pHeadersLen) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getMergeColumns");
        let colLength = Object.keys(this.fields).length - 1;
        for (let index = 0; index < pHeadersLen; index++) {
          retValue.push({
            s: { r: index, c: 0 },
            e: { r: index, c: colLength }
          });
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_EXPORT_EXCEL,
          "error in getMergeColumns",
          err.toString(),
          "getMergeColumns",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    exportData() {
      try {
        if (BaseConfiguration.isDebug) console.log("exportData");

        if (this.fields && this.data && this.data.length) {
          let titles = this.FIELDS;

          let lsData = this.DATA;

          let excelData = [];

          lsData.forEach(data => {
            let excelObj = {};

            Object.keys(titles).forEach(title => {
              if (
                data &&
                title &&
                titles[title] &&
                typeof titles[title].callback == "function"
              ) {
                if (data[titles[title].field] != null)
                  excelObj[title] = titles[title].callback(
                    data[titles[title].field]
                  );
                else excelObj[title] = titles[title].callback(data);
              } else if (data && title && titles[title]) {
                excelObj[title] = data[titles[title]];
              }

              if (excelObj[title]) {
                excelObj[title] = excelObj[title] + "";
              }
            });
            excelData.push(excelObj);
          });

          /*                 export json to Worksheet of Excel
                                  only array possible
                  */
          //    var ws = XLSX.utils.aoa_to_sheet([['NAVEEN']]);

          let headers;
          if (this.title) {
            headers = [...this.title];
          }
          // let headers = [...this.title];

          let workSheet;
          if (headers && headers.length) {
            workSheet = XLSX.utils.aoa_to_sheet([
              ["             " + headers[0] + "             "]
            ]);

            if (headers.length > 1)
              for (let index = 1; index < headers.length; index++) {
                const element = headers[index];
                XLSX.utils.sheet_add_aoa(
                  workSheet,
                  [["              " + element + "          "]],
                  {
                    origin: -1
                  }
                );
              }

            XLSX.utils.sheet_add_json(workSheet, excelData, { origin: -1 });

            const merge = this.getMergeColumns(headers.length);

            workSheet["!merges"] = merge;
          } else {
            // let merge=[
            // 		{s:{r:0,c:0},e:{r:1,c:0}} /* A1:A2 */
            // 	]
            workSheet = XLSX.utils.json_to_sheet([...excelData]);
            if (this.isMergeCells) {
              let merge = this.getMergeCells(this.fields);

              workSheet["!merges"] = merge;
            }
          }

          let workBook = XLSX.utils.book_new();
          // add Worksheet to Workbook
          // Workbook contains one or more worksheets

          XLSX.utils.book_append_sheet(workBook, workSheet, this.worksheet);

          //  XLSX.write(workBook, );
          XLSX.writeFile(workBook, this.name);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_EXPORT_EXCEL,
          "error in exportData",
          err.toString(),
          "exportData",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getMergeCells(pFields) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getMergeCells");
        let colLength = Object.keys(pFields).length;
        for (let index = 0; index < colLength; index++) {
          if (Object.keys(pFields)[index].includes("-merge")) {
            retValue.push({
              s: { r: 0, c: index - 1 },
              e: { r: 0, c: index }
            });
            if (Object.keys(pFields)[index].includes("-mergeI")) {
              for (let col = 0; col < index - 1; col++) {
                retValue.push({
                  s: { r: 0, c: col },
                  e: { r: 1, c: col }
                });
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_EXPORT_EXCEL,
          "error in getMergeCells",
          err.toString(),
          "getMergeCells",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  },

  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_EXPORT_EXCEL,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  }
};
</script>

<style>
</style>